import React from 'react';
import PropTypes from 'prop-types';
import { Loader, Table } from 'semantic-ui-react';

import Fetcher from '../Fetcher';
import SnukTableBody from './SnukTableBody';

const SnukTableFetchBody = (props) => {
  const {
    isLoading, fetchAction, fetchActionArgs, shape, editable, ...rest
  } = props;
  let colSpan = 1;
  shape.forEach((info) => {
    colSpan += parseInt(info.header.colSpan, 10) || 1;
  });
  colSpan += editable ? 1 : 0;
  colSpan = colSpan.toString();
  const LoadingBody = () => (
    <Table.Body>
      <Table.Row>
        <Table.Cell colSpan={colSpan}>
          <Loader size="small" active inline="centered" />
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  );
  return (
    <Fetcher
      as={LoadingBody}
      isLoading={isLoading}
      fetchAction={fetchAction}
      fetchActionArgs={fetchActionArgs}
    >
      <SnukTableBody shape={shape} editable={editable} {...rest} />
    </Fetcher>
  );
};

SnukTableFetchBody.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  fetchAction: PropTypes.func.isRequired,
  fetchActionArgs: PropTypes.arrayOf(PropTypes.any),
  shape: PropTypes.shape({}).isRequired,
  editable: PropTypes.bool,
};

SnukTableFetchBody.defaultProps = {
  fetchActionArgs: [],
  editable: false,
};

export default SnukTableFetchBody;



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableFetchBody.js